import { render, staticRenderFns } from "./ValidationsView.vue?vue&type=template&id=e63a0cce"
import script from "./ValidationsView.vue?vue&type=script&lang=js"
export * from "./ValidationsView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports